<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-if="subsection.title" v-html="subsection.title"></h5>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
        :value="subsection.title"
        placeholder="Введите название"
        @input="$_subsectionMixin_onTitleChange" />
      <div class="text-center mx-auto my-2">
        <b-button variant="outline-primary" @click="addVideo">
          <div v-if="!subsection.file">
            <em class="fa fa-plus mr-1"></em> Добавить видео
          </div>
          <div v-else>
            <em class="fas fa-pen mr-1"></em> Изменить видео
          </div>
        </b-button>
      </div>
      <v-modal-files-upload wrkspcType="video"></v-modal-files-upload>
    </div>
    <div v-if="subsection.file" class="w-75 m-auto" style="height: 60vh;">
      <iframe
        width="100%"
        :src="'/api/files/' + subsection.file.physicalName"
        frameborder="0"
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        height="100%">
      </iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

const VModalFilesUpload = () => import('@/components/content/edit/modals/ModalFilesUpload.vue')

export default {
  name: 'VideoInfoSubSection',
  components: {
    VModalFilesUpload
  },
  mixins: [ContentMixin, SubsectionMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editedText: ''
    }
  },
  computed: {
    ...mapGetters({
      subsection: 'education/getSubsection'
    })
  },
  mounted() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  methods: {
    addVideo() {
      this.$bvModal.show('files-upload-modal')
    }
  }
}
</script>

<style scoped>

</style>
